import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'
import { useAuthStore } from '@/stores/auth'
import IdWraper from '@/model/IdWrapper'

const notificationService = {
    loadNotificationsCount: loadNotificationsCount,
    loadUnreadNotifications: loadUnreadNotifications,
    loadUnreadMessages: loadUnreadMessages,
    markAsRead: markAsRead,
    markAsReadByChatThread: markAsReadByChatThread
}

async function loadNotificationsCount() {
    const authStore = useAuthStore()
    const count = await httpClientWrapper.get('/api/notifications/count', jwtHelper.makeHttpAuthorization())
    authStore.unreadChatsMessages = count.result.unreadMessagesNotificationsCount
    authStore.unreadOperationsMessages = count.result.unreadOperationsNotificationsCount
}

async function loadUnreadNotifications() {
    const notifications = await httpClientWrapper.get('/api/notifications/operations', jwtHelper.makeHttpAuthorization())
    return notifications.result.collection
}

async function loadUnreadMessages() {
    const notifications = await httpClientWrapper.get('/api/notifications/messages', jwtHelper.makeHttpAuthorization())
    return notifications.result.collection
}

function markAsRead(notification) {
    httpClientWrapper.post('/api/notifications/read', new IdWraper(notification.id), jwtHelper.makeHttpAuthorization(), false)
}

function markAsReadByChatThread(chatThreadId) {
    httpClientWrapper.post('/api/notifications/readByChatThread', new IdWraper(chatThreadId), jwtHelper.makeHttpAuthorization(), false)
}

export default notificationService

